var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidCertificationEvidenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5547 13.82H26.4297",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 13.82L10.6953 14.945L14.0703 11.57",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5547 24.32H26.4297",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 24.32L10.6953 25.445L14.0703 22.07",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33.5H22.5C30 33.5 33 30.5 33 23V14C33 6.5 30 3.5 22.5 3.5H13.5C6 3.5 3 6.5 3 14V23C3 30.5 6 33.5 13.5 33.5Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidCertificationEvidenceIcon);
export default __webpack_public_path__ + "static/media/bfid-certification-evidence-icon.5234b1aed825a8f8782d33d6f56585c7.svg";
export { ForwardRef as ReactComponent };